<template>
    <form-group class="form-code bg-transparent mb-0" :error="error">
        <div class="group-code mt-3 mb-2" @click="focusInputCode">
            <div class="row no-gutters px-6">
                <template v-for="n in 6">
                    <div class="col-2" :key="n">
                        <div class="form-group mx-2">
                            <input
                                type="tel"
                                :id="'input-code-'+n"
                                class="form-control text-center"
                                maxlength="1"
                                v-bind:value="getCodeAsArray(n-1)"
                                @keydown="onKeyDown(n, $event)"
                                @keyup.enter="submit"
                            >
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </form-group>
</template>

<script>
    import FormGroup from '@/components/molecules/FormGroup'

    export default {
        name: "FormCode",
        components: {
            FormGroup
        },
        data() {
            return{
                verificationCode: [],
            }
        },
        props: {
            error: [String, Array],
        },
        methods:
        {
            focusInputCode()
            {
                if (this.verificationCode.length == 0) {
                    document.getElementById("input-code-1").focus();
                }
                else {
                    document.getElementById("input-code-" + (this.verificationCode.length + 1)).focus();
                }
            },
            getCodeAsArray(index)
            {
                if (typeof index === "undefined") {
                    return this.verificationCode;
                }
                else {
                    return this.verificationCode[index];
                }
            },

            onKeyDown(position, evt)
            {
                const key = evt.which || evt.keyCode;

                // BACKSPACE
                if (key === 8)
                {
                    evt.preventDefault();

                    this.$set(this.verificationCode, (position-1), '');

                    if (position > 1) {
                        
                        document.getElementById("input-code-"+(position-1)).focus();
                    }
                    this.verificationCode.pop();
                    this.$emit('verification-code', {verificationCode: this.verificationCode})
                    return false;
                }

                // DELETE
                else if (key === 46)
                {
                    evt.preventDefault();
                    this.$set(this.verificationCode, (position-1), '');
                    this.$emit('verification-code', {verificationCode: this.verificationCode})
                    this.verificationCode.pop();
                    return false;
                }

                else {
                    let value = String.fromCharCode(key);

                    if (evt.key && evt.key !== 'Unidentified') {
                        value = evt.key;
                    }

                    if (value && /^\d+$/.test(value))
                    {
                        evt.preventDefault();

                        this.$set(this.verificationCode, (position-1), value);

                        if (position < 6) {
                            document.getElementById("input-code-"+(position+1)).focus();
                        }
                        
                        this.$emit('verification-code', {verificationCode: this.verificationCode})
                        return false;
                    }
                }
            },
        },
        mounted(){
            document.getElementById("input-code-1").focus()
        }
    }
</script>

<style lang="stylus">
    .form-code
        .group-code .form-control
            padding 0.625rem 0!important
            font-size 2rem!important

            border-radius 0!important
            border-width 0 0 1px 0!important
            border-color $gray-400!important
            height auto!important
            line-height 1.25!important
            background-color transparent!important
            box-shadow none!important
            outline 0!important
            transition border-color 0.15s ease-in-out!important

            &:focus
                border-color $primary!important

            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus textarea:-webkit-autofill {
                -webkit-box-shadow 0 0 0px 1000px #F2F2F2 inset !important
            }
        .form-group 
            background-color #f2f2f2
</style>